'use strict'

// import { CookiePolicy } from './lib/CookiePolicy'
import { Svg } from './lib/Svg'
import { TelGrant } from './lib/TelGrant'
import { Smooth } from './lib/Smooth'
import { Drawer } from './lib/Drawer'
import { ScrollStatus } from './lib/ScrollStatus'
import { ScrollAnimation } from './lib/ScrollAnimation'
import { Accordion } from './lib/Accordion'
import { Slider } from './lib/Slider'
import { KvSlider } from './lib/KvSlider'
import { MangaSlider } from './lib/MangaSlider'
import { MangaModalSlider } from './lib/MangaModalSlider'
import { Modal } from './lib/Modal'

// new CookiePolicy('optout')
new Svg()
new TelGrant()
new Smooth()
new Drawer()
new ScrollStatus()
new ScrollAnimation()
new Accordion()
new Slider()
new KvSlider()
new MangaSlider()
new MangaModalSlider()
new Modal()
